"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreSettingsToJSON = exports.StoreSettingsFromJSONTyped = exports.StoreSettingsFromJSON = exports.instanceOfStoreSettings = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StoreSettings interface.
 */
function instanceOfStoreSettings(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreSettings = instanceOfStoreSettings;
function StoreSettingsFromJSON(json) {
    return StoreSettingsFromJSONTyped(json, false);
}
exports.StoreSettingsFromJSON = StoreSettingsFromJSON;
function StoreSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'urlSlug': !(0, runtime_1.exists)(json, 'url_slug') ? undefined : json['url_slug'],
        'campaignClosesAt': !(0, runtime_1.exists)(json, 'campaign_closes_at') ? undefined : json['campaign_closes_at'],
        'autofulfill': !(0, runtime_1.exists)(json, 'autofulfill') ? undefined : json['autofulfill'],
        'enableOrderPlacedEmail': !(0, runtime_1.exists)(json, 'enable_order_placed_email') ? undefined : json['enable_order_placed_email'],
    };
}
exports.StoreSettingsFromJSONTyped = StoreSettingsFromJSONTyped;
function StoreSettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'url_slug': value.urlSlug,
        'campaign_closes_at': value.campaignClosesAt,
        'autofulfill': value.autofulfill,
        'enable_order_placed_email': value.enableOrderPlacedEmail,
    };
}
exports.StoreSettingsToJSON = StoreSettingsToJSON;
